<div class="box-form-ui container finantial-information-container">
  <h2>{{ name }}, continúa completando tus datos financieros.</h2>
  <form
    id="FinantialInformationForm"
    class="finantial-information-form"
    autocomplete="off"
    [formGroup]="finantialInformationForm"
    (ngSubmit)="onSubmit()"
  >
    <mat-form-field appearance="fill" id="ActiveExpenses">
      <mat-label class="label"> Lo que tienes (Activos) </mat-label>
      <input
        matInput
        type="tel"
        appCurrencyMask
        inputmode="numeric"
        formControlName="activeExpenses"
        maxlength="20"
        id="activeExpensesInput"
      />
      <mat-error
        *ngIf="
          finantialInformationForm.controls['activeExpenses'].hasError(
            'required'
          )
        "
      >
        Este campo es obligatorio
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" id="PassiveExpenses">
      <mat-label class="label"> Lo que debes (Pasivos) </mat-label>
      <input
        matInput
        type="tel"
        appCurrencyMask
        inputmode="numeric"
        formControlName="passiveExpenses"
        maxlength="20"
        id="passiveExpensesInput"
      />
      <mat-error
        *ngIf="
          finantialInformationForm.controls['passiveExpenses'].hasError(
            'required'
          )
        "
      >
        Este campo es obligatorio
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" id="monthlyExpenses">
      <mat-label class="label"> Total de tus gastos mensuales </mat-label>
      <input
        matInput
        type="tel"
        appCurrencyMask
        inputmode="numeric"
        formControlName="monthlyExpenses"
        maxlength="20"
        id="monthlyExpensesInput"
      />
      <mat-error
        *ngIf="
          finantialInformationForm.controls['monthlyExpenses'].hasError(
            'required'
          )
        "
      >
        Este campo es obligatorio
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" id="monthlyIncome">
      <mat-label class="label"> Total de tus ingresos mensuales </mat-label>
      <input
        matInput
        type="tel"
        appCurrencyMask
        inputmode="numeric"
        formControlName="monthlyIncome"
        maxlength="20"
        id="monthlyIncomeInput"
      />
      <mat-error
        *ngIf="
          finantialInformationForm.controls['monthlyIncome'].hasError(
            'required'
          )
        "
      >
        Este campo es obligatorio
      </mat-error>

      <mat-error
        *ngIf="
          !finantialInformationForm.controls['monthlyIncome'].hasError(
            'required'
          ) &&
          finantialInformationForm.controls['monthlyIncome'].hasError(
            'notBiggerThan'
          )
        "
      >
        Tus ingresos no pueden ser inferiores a $ 10.000 pesos.
      </mat-error>

      <mat-error
        *ngIf="
          !finantialInformationForm.controls['monthlyIncome'].hasError(
            'required'
          ) &&
          finantialInformationForm.controls['monthlyIncome'].hasError(
            'notLesserThan'
          )
        "
      >
        Tus ingresos no pueden ser superiores a $ 9.999.999.999
      </mat-error>
    </mat-form-field>
    <label for="">¿Realizas alguna de estas operaciones internacionales?</label>
    <mat-form-field appearance="fill" class="operation-type" id="OperationType">
      <mat-label class="label">Selecciona</mat-label>
      <mat-select
        appSelectOverlayPosition
        disableOptionCentering
        formControlName="operationType"
      >
        <mat-option *ngFor="let opType of opTypes" [value]="opType.value">
          {{ opType.viewValue }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          finantialInformationForm.controls['operationType'].hasError(
            'required'
          )
        "
      >
        Este campo es obligatorio
      </mat-error>
    </mat-form-field>
    <div class="radio-button-group-wrapper">
      <p>¿Realizas transacciones en moneda extranjera?</p>
      <mat-radio-group
        class="additional-data-question-radio"
        formControlName="additionalDataQuestion"
      >
        <mat-radio-button value="true">Si</mat-radio-button>
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="box-btn-submit">
      <button
        class="btn btn-degraded blue"
        type="submit"
        [disabled]="!finantialInformationForm.valid"
        id="SubmitContactInformationForm"
      >
        Continuar
      </button>
    </div>
  </form>
</div>
